export const WINDOW = 'WINDOW'
export const APP = 'APP'
export const CONTEXT = 'CONTEXT'

export default {
}



// WEBPACK FOOTER //
// ./src/config.js